import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {PresentationTypeEnum} from '../../../../Shared/Enum/presentation-type.enum';
import {FilterButtonTypesEnum} from '../../../../Shared/Enum/filter-button-types.enum';
import {HapticsImpactManagerService} from '../../../../Services/Platform/Capacitor/haptics-impact-manager.service';
import {AnimationsManagerService} from '../../../../Services/Platform/Ionic/animations-manager.service';
import {ModalSelectorComponent} from '../../yu-selector/modal-selector/modal-selector.component';
import {YuDatetimeModal} from '../../yu-datetime/yu-datetime.component';
import {format} from 'date-fns';

@Component({
  selector: 'yu-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss'],
  standalone: false
})
export class FilterButtonComponent implements OnInit, OnChanges {

  @Input() items: any[] = [];
  @Input() label: string = '';

  @Input() itemsValueField: string = 'id';
  @Input() itemsLabelField: string = 'nombre';
  @Input() itemsImageField: string = '';

  @Input() groupItems: boolean = false;
  @Input() groupValueField: string = 'id';
  @Input() groupTextField: string = 'nombre';

  @Input() disabled: boolean = false;
  @Input() disabledReset: boolean = false;

  @Input() minDate: string = '';
  @Input() maxDate: string = '';

  @Input() type: string = FilterButtonTypesEnum.list;

  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  valueLabel: string = '';

  constructor(
    protected modalCtrl: ModalController,
    protected animationsCtrl: AnimationsManagerService,
    protected hapticsImpactManager: HapticsImpactManagerService,
  ) {
  }

  ngOnInit() {
    this.setValueLabel();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] || changes['items']) {
      this.setValueLabel();
    }
  }


  /**
   * Mostrar el valor/es seleccionado
   *
   */
  setValueLabel() {
    switch (this.type) {
      case FilterButtonTypesEnum.list: {
        const itemSelected = this.items?.find((item) => item[this.itemsValueField] === this.value);
        this.valueLabel = itemSelected ? itemSelected[this.itemsLabelField] : 'COMMON.ALL';
        break;
      }

      case FilterButtonTypesEnum.multiList: {
        const itemsSelected = this.items?.filter((item) => this.value?.includes(item[this.itemsValueField]));

        if (!itemsSelected || itemsSelected.length === 0) {
          this.valueLabel = 'COMMON.ALL';
          return;
        }

        this.valueLabel = itemsSelected.length > 1
          ? itemsSelected[0][this.itemsLabelField] + ' + ' + (itemsSelected.length - 1) + ' más'
          : itemsSelected[0][this.itemsLabelField];

        break;
      }

      case FilterButtonTypesEnum.date:
        this.valueLabel = this.value ? format(new Date(this.value), 'dd/MM/yyyy') : '--';
        break;

      case FilterButtonTypesEnum.monthYear:
        this.valueLabel = this.value ? format(new Date(this.value), 'MMMM - yyyy') : '--';
        break;
    }
  }


  /**
   * Abrir el selector
   *
   */
  doAction() {
    this.hapticsImpactManager.hapticsImpactHeavy();

    switch (this.type) {
      case FilterButtonTypesEnum.list:
        this.openSearchSelector();
        break;

      case FilterButtonTypesEnum.multiList:
        this.openSearchSelector(true);
        break;

      case FilterButtonTypesEnum.date:
        this.openDatetime();
        break;

      case FilterButtonTypesEnum.monthYear:
        this.openDatetime(true);
        break;
    }
  }


  /**
   * Abrir selector
   *
   */
  async openSearchSelector(multiple = false) {
    const modal = await this.modalCtrl.create({
      component: ModalSelectorComponent,
      componentProps: {
        title: this.label,
        items: this.items,
        value: this.value,
        itemsValueField: this.itemsValueField,
        itemsLabelField: this.itemsLabelField,
        itemsImageField: this.itemsImageField,
        groupItems: this.groupItems,
        groupValueField: this.groupValueField,
        groupTextField: this.groupTextField,
        disabledReset: this.disabledReset,
        multiple
      },
      cssClass: 'yu-modal',
    });

    modal.onDidDismiss().then((data) => {
      if (data.data || data.data === 0 || data.role === 'reset') {
        this.valueChange.emit(data.data);
        this.setValueLabel();
      }
    });

    await modal.present();
  }


  /**
   * Abrir selector de fecha
   *
   */
  async openDatetime(monthYear = false) {
    const modal = await this.modalCtrl.create({
      component: YuDatetimeModal,
      enterAnimation: this.animationsCtrl.showModalAnimation,
      leaveAnimation: this.animationsCtrl.hideModalAnimation,
      componentProps: {
        dateValue: this.value,
        presentation: monthYear ? PresentationTypeEnum.MonthYear : PresentationTypeEnum.Date,
        min: this.minDate || undefined,
        max: this.maxDate || undefined,
        inputOutputFormat: 'yyyy-MM-dd',
      },
      cssClass: 'transparent-modal',
    });

    modal.onDidDismiss().then((data) => {
      if (data?.data) {
        this.valueChange.emit(data.data);
        this.setValueLabel();
      }
    });

    await modal.present();
  }

}
